import FieldsInput from "../../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";

const ContactLastName = (props) => {
  const { contactLastName } = props;
  const { t } = useTranslation();
  const style = Style();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("last_name")}
          validationMessage={props.errors?.contactLastName?.message}
          id="contactLastName"
          placeholder={t("enter_last_name")}
          name="contactLastName"
          inputDefaultValue={contactLastName}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("contactLastName", {
            required: `${t("validation_message.lastname_is_required")}`,
          })}
        />
      </Stack>
    </>
  );
};

export default ContactLastName;
